import type {TokenClaimsSerializer} from "@/generated/DjangoTypes";
import {SETTINGS_SCOPE_SECTIONS} from "@/store/constants";
import {settingsModalAtom} from "@/store/jotaiAtoms";
import useTokenStore from "@/store/token";
import {fetchCompany} from "@/utils/loaderUtils";
import {createFileRoute, redirect} from "@tanstack/react-router";
import {zodValidator} from "@tanstack/zod-adapter";
import {getDefaultStore} from "jotai";
import {jwtDecode} from "jwt-decode";
import {z} from "zod";

export const Route = createFileRoute("/_authenticated/company/$companyId/edit")({
  params: {
    parse: raw => ({companyId: +raw.companyId}),
    stringify: params => ({companyId: params.companyId?.toString()}),
  },
  validateSearch: zodValidator(
    z.object({
      payment_failed: z.boolean().optional(),
      section: z.enum(SETTINGS_SCOPE_SECTIONS).optional().catch(undefined),
    }),
  ),
  loaderDeps: ({search}) => ({section: search.section}),
  loader: async ({deps, params}) => {
    const token = useTokenStore.getState().access;

    if (!token) {
      throw redirect({to: "/login", replace: true});
    }

    const claims = jwtDecode<TokenClaimsSerializer>(token);
    const isAdmin = claims.access_level === "COMPANY_ADMIN" || claims.access_level === "INFLUENCER_ADMIN";
    const isAgency = claims.access_level === "AGENCY";

    if (isAdmin || isAgency) {
      const company = await fetchCompany(params.companyId);

      if (company.agency?.multiple_brands) {
        getDefaultStore().set(settingsModalAtom, {
          scope: {id: company.id, type: "brand"},
          section: deps.section ?? "info",
        });

        throw redirect({
          to: "/agency/$agencyId/subbrand/$companyId",
          params: {agencyId: company.agency.id, companyId: company.id},
          replace: true,
          search: true,
        });
      }
    }

    getDefaultStore().set(settingsModalAtom, {
      scope: {id: params.companyId, type: "brand"},
      section: deps.section ?? "info",
    });

    throw redirect({to: "/company/$companyId", params: {companyId: params.companyId}, replace: true, search: true});
  },
});
